import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  Card,
  Popper,
  CardHeader,
  Divider,
  CardContent,
  Grid,
  TextField,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import genService from 'src/services/generalServices';
import { es as esLocale } from 'date-fns/locale/es';

const useStyles = makeStyles((theme) => ({
  root: {},
  bottomSpace: {
    marginBottom: theme.spacing(1)
  },
}));

const BusquedaOrdenes = ({
  openPopper,
  anchorEl,
  setFechaDesde,
  setFechaHasta,
  fechaDesde,
  fechaHasta,
  onSubmitAdv,
  comboOrdenEstatus,
  comboAnalistas,
  rolUsuario
}) => {
  const { register, handleSubmit, control } = useForm();
  const classes = useStyles();
  const [openFechaHasta, setOpenFechaHasta] = React.useState(false);
  const [openFechaDesde, setOpenFechaDesde] = React.useState(false);

  return (
    <Popper
      open={openPopper}
      anchorEl={anchorEl}
      modifiers={[{ name: 'computeStyles', options: { gpuAcceleration: false } }]}
    >
      <form onSubmit={handleSubmit((data) => onSubmitAdv(data, 'adv'))}>
        <Card className={classes.root}>
          <CardHeader
            avatar={<Search fontSize="small" color="primary" />}
            subheader="Búsqueda avanzada"
            style={{ padding: '5px' }}
          />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Folio"
                  size="small"
                  {...register('folio')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Nombre Cliente"
                  size="small"
                  {...register('nombreCliente')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Investigado"
                  size="small"
                  {...register('investigado')}
                  onInput={genService.toUpperCase}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Correo electrónico"
                  size="small"
                  {...register('email')}
                />
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <TextField
                  fullWidth
                  label="Teléfono"
                  size="small"
                  {...register('telefono')}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <DatePicker
                    open={openFechaDesde}
                    onOpen={() => setOpenFechaDesde(true)}
                    onClose={() => setOpenFechaDesde(false)}
                    onChange={setFechaDesde}
                    format="dd/MM/yyyy"
                    label="Desde"
                    value={fechaDesde}
                    slotProps={{
                      textField: {
                        name: 'desde',
                        margin: 'normal'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                  <DatePicker
                    open={openFechaHasta}
                    onOpen={() => setOpenFechaHasta(true)}
                    onClose={() => setOpenFechaHasta(false)}
                    onChange={setFechaHasta}
                    format="dd/MM/yyyy"
                    label="Hasta"
                    value={fechaHasta}
                    slotProps={{
                      textField: {
                        name: 'hasta',
                        margin: 'normal'
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid
                size={{
                  md: 6,
                  xs: 12
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel htmlFor="ordenEstatus-select">
                    Seleccione un Estatus
                  </InputLabel>
                  <Controller
                    control={control}
                    name="idOrdenEstatus"
                    defaultValue={0}
                    render={({ field }) => (
                      <Select
                        {...field}
                        id="OrdenEstatus-select"
                        label="Seleccione un Estatus"
                        MenuProps={{
                          disablePortal: true,
                          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                          transformOrigin: { vertical: 'top', horizontal: 'center' },
                          PaperProps: { style: { position: 'sticky' } }
                        }}
                      >
                        <MenuItem key={0} value={0}>Seleccione un Estatus</MenuItem>
                        {comboOrdenEstatus.map((status) => (
                          <MenuItem
                            key={status.value}
                            value={status.value}
                          >
                            {status.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
              </Grid>
              {rolUsuario === 'ADMINISTRADOR'
                ? (
                  <Grid
                    size={{
                      md: 6,
                      xs: 12
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size="small"
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel htmlFor="analistas-select">
                        Seleccione un Analista
                      </InputLabel>
                      <Controller
                        control={control}
                        name="idAnalista"
                        defaultValue={0}
                        render={({ field }) => (
                          <Select
                            {...field}
                            id="analistas-select"
                            label="Seleccione un Analista"
                            MenuProps={{
                              disablePortal: true,
                              anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                              transformOrigin: { vertical: 'top', horizontal: 'center' },
                              PaperProps: { style: { position: 'sticky' } }
                            }}
                          >
                            <MenuItem key={0} value={0}>Seleccione un Analista</MenuItem>
                            {comboAnalistas.map((status) => (
                              <MenuItem
                                key={status.value}
                                value={status.value}
                              >
                                {`${status.label} - (${status.usuario})`}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                    </FormControl>
                  </Grid>
                ) : (
                  null
                )}
            </Grid>
            <div className={classes.bottomSpace} />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                type="submit"
              >
                Buscar
              </Button>
            </Box>
          </CardContent>
        </Card>
      </form>
    </Popper>
  );
};

BusquedaOrdenes.propTypes = {
  anchorEl: PropTypes.object,
  openPopper: PropTypes.bool,
  setFechaDesde: PropTypes.func,
  setFechaHasta: PropTypes.func,
  fechaDesde: PropTypes.string,
  fechaHasta: PropTypes.string,
  onSubmitAdv: PropTypes.func,
  comboOrdenEstatus: PropTypes.array,
  comboAnalistas: PropTypes.array,
  rolUsuario: PropTypes.string
};
export default BusquedaOrdenes;
